import gql from 'graphql-tag';

export const getIsTwoFactorValid = gql`
  query getIsTwoFactorValid {
    me {
      isTwoFactorValid
    }
  }
`;
